import { ReactComponent as DeleteSvg } from '../../assets/icons/delete.svg';

export const DeleteIcon: SvgIcon = (props) => {
    return <DeleteSvg {...props} />;
};
